// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"364":"2f565c65054334d8","681":"5068774ea30954a4"}[chunkId] + ".js";
};